import { Box } from '@mantine/core';
import React from 'react';

import { VectorCadStudio } from '../features/vector-cad/components/VectorCadStudio';

export function VectorCadPage() {
  return (
    <Box>
      <VectorCadStudio />
    </Box>
  );
}
